import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getpath } from "../actions/get-path";
import { timeupdate } from "../actions/timeupdate";
import TimeBuilder from "../components/shared-components/timesheet/TimeEntryBuilder";
import { queryaction } from "../actions/get-action";
import { modalhandler } from "../actions/modal-handler";
class TimeEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmed: false,
      currentweek: {},
      currentdates: null,
      readonly: false,
      monday: null,
      realtimesheet: [],
      empnumber: null,
      wods: [],
      jobs: [],
      weekyyyymmdd: []
    };
  }
  render() {
    return (
      <div className="TimeEntry" id="timetable">
        <TimeBuilder />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    employees: state.employees.employees,
    jobs: state.jobs.assignedjobs,
    wods: state.workorders.derivitives,
    mobile: state.mobile,
    time: state.time.timequerydata,
    myinfo: state.myinfo.employeeinfo
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handlemodal: modalhandler,
      queryaction: queryaction,
      getpath: getpath,
      timeupdate: timeupdate
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(TimeEntry);



// WEBPACK FOOTER //
// ./src/containers/TimeEntry.js